import React, { Component } from "react";
import {
  Container,
  Tabs,
  Tab,
  Navbar,
  Button,
  Nav,
  Row,
  Col,
} from "react-bootstrap";
// import InventoryTargetSettingsArea from "./area/inventory_target_area";
// import InventoryTargetSettingsOverall from "./overall/inventory_target_overall";
// import InventoryTargetSettingsCluster from "./cluster/inventory_target_cluster";

import InventoryTargetSettingsBranch from "./branch/inventory_target_branch";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import history from "../../../history";

class InventoryTargetSettingsLayout extends Component {
  state = {
    activeKey: null,
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const tags = params.get("scope");
    this.setState({ activeKey: tags ? tags : "Branch" });
  }

  renderOptions = () => {
    return (
      <Navbar className="rounded">
        <Navbar.Brand>
          <Link className="mr-2" to="/pawnshop-reports/settings">
            <Button variant="outline-secondary">
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          </Link>
          Inventory Targets
        </Navbar.Brand>
        <Navbar.Collapse>
          <Nav className="mr-auto" />
        </Navbar.Collapse>
      </Navbar>
    );
  };

  render() {
    const navigation = [
      // {
      //   name: "Overall",
      //   path: "/pawnshop-reports/settings/target/branch",
      //   content: <InventoryTargetSettingsBranch />,
      // },
      // {
      //   name: "Cluster",
      //   path: "/pawnshop-reports/settings/target/cluster",
      //   content: <InventoryTargetSettingsCluster />,
      // },
      // {
      //   name: "Area",
      //   path: "/pawnshop-reports/settings/target/area",
      //   content: <InventoryTargetSettingsArea />,
      // },
      {
        name: "Branch",
        path: "/pawnshop-reports/settings/target/branch",
        content: <InventoryTargetSettingsBranch />,
      },
    ];

    return (
      <Container
        variant="pills"
        className="bg-white p-3 rounded shadow-sm"
        fluid
      >
        <Row>
          <Col>{this.renderOptions()}</Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Tabs
              onSelect={(e) => {
                history.push({
                  pathname: "/pawnshop-reports/settings/target",
                  search: `?scope=${e}`,
                });
                this.setState({ activeKey: e });
              }}
              activeKey={this.state.activeKey}
            >
              {navigation.map((item, idx) => {
                return (
                  <Tab title={item.name} eventKey={item.name} key={idx}>
                    {item.content}
                  </Tab>
                );
              })}
            </Tabs>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default InventoryTargetSettingsLayout;
